import { subMenuNamesAndOptions } from './publicCatalogDropdownConstants';
export const getSubMenuNameFromSubMenuOption = (filter, subMenuOption) => {
  const subMenus = subMenuNamesAndOptions[filter];
  const foundSubMenu = Object.entries(subMenus).find(([__subMenuName, subMenuOptions]) => subMenuOptions.includes(subMenuOption));
  return foundSubMenu ? foundSubMenu[0] : null;
};
export const getFilterNameFromSubMenuName = subMenuName => {
  const foundFilter = Object.entries(subMenuNamesAndOptions).find(([__filterName, subMenu]) => Object.keys(subMenu).includes(subMenuName));
  return foundFilter ? foundFilter[0] : null;
};